import { Checkbox, TableCell } from '@material-ui/core';
import clsx from 'clsx';
import React, { useCallback, useState } from 'react';
import { TableRow } from '@material-ui/core';
import { useStyles } from './table';
import EditIcon from '@material-ui/icons/Edit';
import Check from '@material-ui/icons/Check';
import Cross from '@material-ui/icons/Clear';
import { RIDER_STATUSES, MobileNo } from './utils';
import API from '../../../create/api';

export default function Rows(props: any = {}) {
  const classes = useStyles();

  const { row, serial, fetchAPI, checkboxes, handleCheckBox } = props;

  const [editState, setEditState] = useState({
    values: {
      cod: row?.merchant_COD,
      status: row?.status,
      address: row?.address,
    },
    isEditing: {
      cod: false,
      status: false,
      address: false,
    },
  });

  function updateField(field: string, value: any) {
    const payload: any = { [field]: value };

    if (field === 'cod') {
      payload.collected_amount = value;
      payload.return_product_price = (row.merchant_COD ?? 0) - value;
    }

    return API.update(`${process.env.REACT_APP_API_SERVER}/parcels`, row?.id, payload).finally(() => {
      fetchAPI();
      setEditState((prevState) => ({
        ...prevState,
        isEditing: { ...prevState.isEditing, [field]: false },
        values: { ...prevState.values, [field]: row[field] },
      }));
    });
  }

  return (
    <React.Fragment>
      <TableRow>
        <TableCell className={classes.hidePrint} style={{ maxWidth: '10px' }} align="left">
          <Checkbox
            name={`checkbox-${row.id}`}
            checked={checkboxes[`checkbox-${row.id}`] ?? false}
            onChange={(e) => {
              handleCheckBox(e, row.id);
            }}
          />
        </TableCell>
        <TableCell className={classes.printStyle}>{serial}</TableCell>
        <TableCell className={classes.printStyle} align="center">
          {row.id}
          <hr style={{ margin: 0 }} />
          {row.memoNo}
        </TableCell>
        <TableCell className={classes.printStyle} align="center">
          {row?.company?.name}
          <hr style={{ margin: 0 }} />
          {row?.booking_date}
        </TableCell>
        <TableCell className={clsx(classes.printStyle)} align="left">
          {row.customerName} <br />
          <span> {MobileNo(row.phoneNumber)}</span>
        </TableCell>
        <TableCell className={classes.printStyle} align="left">
          {editState.isEditing.address ? (
            <>
              <input
                type="text"
                value={editState.values.address}
                onChange={(e) =>
                  setEditState({
                    ...editState,
                    values: { ...editState.values, address: e.target.value },
                  })
                }
              />
              <Check
                onClick={() => {
                  updateField('address', editState.values.address);
                }}
                className="cursor-pointer"
              />
              <Cross
                onClick={() =>
                  setEditState({
                    ...editState,
                    isEditing: { ...editState.isEditing, address: false },
                    values: { ...editState.values, address: row.address },
                  })
                }
                className="cursor-pointer"
              />
            </>
          ) : (
            <>
              {row.address}
              <EditIcon
                className={clsx(classes.hidePrint, 'cursor-pointer')}
                onClick={() =>
                  setEditState({
                    ...editState,
                    isEditing: { ...editState.isEditing, address: true },
                  })
                }
              />
            </>
          )}
        </TableCell>
        <TableCell className={classes.hidePrint} align="left">
          {editState.isEditing.status ? (
            <div className="flex items-center">
              <select
                onChange={(e) =>
                  setEditState({
                    ...editState,
                    values: { ...editState.values, status: e.target.value },
                  })
                }
              >
                {Object.keys(RIDER_STATUSES).map((status) => (
                  <option key={status} value={status} selected={row.status == status}>
                    {RIDER_STATUSES[status]}
                  </option>
                ))}
              </select>
              <Check
                onClick={() => {
                  updateField('status', editState.values.status);
                }}
                className="cursor-pointer"
              />
              <Cross
                onClick={() =>
                  setEditState({
                    ...editState,
                    isEditing: { ...editState.isEditing, status: false },
                    values: { ...editState.values, status: row.status },
                  })
                }
                className="cursor-pointer"
              />
            </div>
          ) : (
            <div className="flex items-center">
              {RIDER_STATUSES[row.status] ?? ''}
              <EditIcon
                onClick={() =>
                  setEditState({
                    ...editState,
                    isEditing: { ...editState.isEditing, status: true },
                  })
                }
                className="cursor-pointer"
              />
            </div>
          )}
        </TableCell>
        <TableCell className={classes.printStyle} align="right">
          {editState.isEditing.cod ? (
            <div className="flex items-center">
              <input
                type="number"
                value={editState.values.cod}
                onChange={(e) =>
                  setEditState({
                    ...editState,
                    values: { ...editState.values, cod: Number(e.target.value) },
                  })
                }
              />
              <Check
                onClick={() => {
                  updateField('cod', editState.values.cod);
                }}
                className="cursor-pointer"
              />
              <Cross
                onClick={() =>
                  setEditState({
                    ...editState,
                    isEditing: { ...editState.isEditing, cod: false },
                    values: { ...editState.values, cod: row.merchant_COD },
                  })
                }
                className="cursor-pointer"
              />
            </div>
          ) : (
            <div className="flex items-center">
              {row?.collected_amount > 0 && row?.collected_amount !== row?.merchant_COD ? (
                <span>
                  <span className="line-through mr-1">{row?.merchant_COD}</span>
                  <span>{row?.collected_amount}</span>
                </span>
              ) : (
                row?.merchant_COD ?? 'N/A'
              )}
              {(row?.status === 'PARTIALLY_DELIVERED_BY_RIDER' || row?.status === 'DELIVERED_BY_RIDER') && (
                <EditIcon
                  className={clsx(classes.hidePrint, 'cursor-pointer')}
                  onClick={() =>
                    setEditState({
                      ...editState,
                      isEditing: { ...editState.isEditing, cod: true },
                    })
                  }
                />
              )}
            </div>
          )}
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
